import classNames from "classnames";

import "./_UimLoadingSpinner.scss";

type UimLoadingSpinnerProps = {
  spinnerClassName?: string;
  imagePlaceholder?: string;
};

const baseClass = "EBRO_UimLoadingSpinner";

const UimLoadingSpinner = ({
  spinnerClassName,
  imagePlaceholder = "",
}: UimLoadingSpinnerProps) => (
  <div className={classNames(baseClass, spinnerClassName)}>
    <div className={`${baseClass}_Container`}>
      {imagePlaceholder ? (
        <img
          src={imagePlaceholder}
          alt="Placeholder"
          className={`${baseClass}_Container_Image`}
        />
      ) : (
        <div className={`${baseClass}_Container_Item`} />
      )}
    </div>
  </div>
);

export default UimLoadingSpinner;
